const RECENT_METERS_COOKIE = "ppex_us_meters";
const MAX_RECENT_METERS = 10;

export function getRecentMeters(): string[] {
    const match = document.cookie.match(new RegExp(`(?:^|; )${RECENT_METERS_COOKIE}=([^;]*)`));
    if (!match) {
        return [];
    }
    return decodeURIComponent(match[1])
        .split(",")
        .map((m) => m.trim())
        .filter(Boolean);
}

export function rememberMeter(meterNumber: string) {
    const meters = getRecentMeters().filter((m) => m !== meterNumber);
    meters.unshift(meterNumber);
    const value = encodeURIComponent(meters.slice(0, MAX_RECENT_METERS).join(","));
    document.cookie = `${RECENT_METERS_COOKIE}=${value}; path=/; max-age=31536000; SameSite=Lax`;
}
